import React, {memo} from 'react';
import {Transition, TransitionGroup, Layout, DateContext, Icon} from 'components';
import {StickyItems} from '.';
import {some, size, useSelector, useNamedSelector} from 'helpers';
import {allDay, anyTime, navigate} from 'store/calendar';
import css from './header.module.scss';

export function Header({ slide, className }) {
  const { dates } = useNamedSelector('calendar.settings');
  const hasAllDay = useSelector(state => some(dates.map(date => allDay(state, { date })), size));
  const hasAnyTime = useSelector(state => some(dates.map(date => anyTime(state, { date })), size));
  return (
    <Layout.Header className={css('header')}>
      <div className={css('wrap', className)}>
        <TransitionGroup>
          { [ dates ].map(dates =>
            <Transition key={dates.join(',')} timeout={200}>
              { transition =>
                <Columns dates={dates} transition={transition} hasAllDay={hasAllDay} hasAnyTime={hasAnyTime} />
              }
            </Transition>
          ) }
        </TransitionGroup>
      </div>
      <div className={css.labels}>
        <div className={css.placeholder} />
        { hasAnyTime && <div>Any time</div> }
        { hasAllDay && <div>All day</div> }
      </div>
      <Icon name="chevron-left" className={css('chevron-left')} onClick={slide.prev} />
      <Icon name="chevron-right" className={css('chevron-right')} onClick={slide.next} />
    </Layout.Header>
  );
}

const Columns = memo(({ dates, transition, hasAnyTime, hasAllDay }) => {
  const { currentDate } = useNamedSelector('calendar.settings');
  return (
    <ul className={css('container', transition, transition, window.pageYOffset /* trigger reflow for animations */)}>
      { dates.map(date =>
        <li key={date.unix()} className={css('item')}>
          <DateContext.Provider value={date}>
            <div className={css('heading', { isSelected: currentDate.isSame(date) })} onClick={() => navigate(date)}>
              { /day|tomorrow/i.test(date.calendar()) ? date.calendar() : date.format('MMM D') }
              <small>{ date.format('ddd') }</small>
            </div>
            { hasAnyTime && <StickyItems selector="calendar.anyTime" date={date} size={dates.length} /> }
            { hasAllDay && <StickyItems selector="calendar.allDay" date={date} size={dates.length} /> }
          </DateContext.Provider>
        </li>
      ) }
    </ul>
  );
});
